module.exports = __webpack_public_path__ + "img/finance_planner.a25a8a1c.png";